import React, { useRef, useState } from "react";
import Tasks from "./Tasks";
import Frequency from "./Frequencies";
import { CiCirclePlus } from "react-icons/ci";
import FilterIcon from "../../../../Assets/Images/Svg/FilterIcon.svg";
import { Form, Input, message, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { convertUTCDate } from "../../../../utils/convertionFunc";
import rpmService from "../../../../Services/rpmService";
import { useDispatch } from "react-redux";
import {
  fetchRpmFrequenciesList,
  fetchRpmTasksList,
} from "../../../../Redux/actions/rpmActions";
import FrequencyFilter from "./Frequencies/frequencyFilter";
import TaskFilter from "./Tasks/taskFilter";
import Layouts from "../../../Layouts";

function Index() {
  const [toggleState, setToggleState] = useState("Task");
  const [addNewModal, setAddNewModal] = useState(false);
  const [taskFiltered, setTaskFiltered] = useState(false);
  const [frequencyFiltered, setFrequencyFiltered] = useState(false);
  const [loader, setLoader] = useState(false);
  const formRef = useRef();
  const dispatch = useDispatch();
  const [filterModal, setFilterModal] = useState(false);
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const handleNewModal = (action) => {
    if (action === "open") {
      setAddNewModal(true);
    } else if (action === "close") {
      setAddNewModal(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, task, frequency } = formRef.current.getFieldValue();

    if (toggleState === "Task") {
      if (!title || !task) {
        message.error("Please fill in all required fields");
        return;
      }
    } else {
      if (!title || !frequency) {
        message.error("Please fill in all required fields");
        return;
      }
    }
    setLoader(true);
    const payload = {
      account_Id: loggedUser?.user?.account_Id,
      clinic_Id: loggedUser?.user?.clinic_Id,
      userId: loggedUser?.user?.userId,
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      description: toggleState === "Task" ? task : frequency,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      name: title,
      status: 1,
    };

    if (toggleState === "Task") {
      payload.taskCreatedBy = loggedUser?.user?.userId;
      try {
        await rpmService.addNewTask(payload);
        setLoader(false);
        setAddNewModal(false);
        dispatch(fetchRpmTasksList({ status: 1 }));
      } catch (e) {
        setLoader(false);
        console.error(e);
      }
    } else {
      payload.frequencyCreatedBy = loggedUser?.user?.userId;
      try {
        await rpmService.addNewFrequency(payload);
        setLoader(false);
        setAddNewModal(false);
        dispatch(fetchRpmFrequenciesList({ status: 1 }));
      } catch (e) {
        setLoader(false);
        console.error(e);
      }
    }
  };

  const handleFilterModal = () => {
    setFilterModal(!filterModal);
  };

  const handleClearFilter = () => {
    if (toggleState === "Task") {
      dispatch(fetchRpmTasksList({ status: 1 }));
      setTaskFiltered(false);
    } else {
      dispatch(fetchRpmFrequenciesList({ status: 1 }));
      setFrequencyFiltered(false);
    }
  };

  return (
    <Layouts>
      <div div className="p-3">
        <div className="flex justify-between items-center py-3 px-6 sticky top-3 bg-white">
          <div className="">
            <h1 className="font-bold text-xl">Task/ Frequency</h1>
          </div>
          <div className="flex gap-4">
            <div>
              <button
                onClick={() => handleNewModal("open")}
                className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
              >
                <span className="w-5 h-5">
                  <CiCirclePlus className="w-full text-[#189FAA] h-full" />
                </span>
                <span className="">New</span>
              </button>
            </div>
            <div>
              <button
                onClick={handleFilterModal}
                className="w-20 h-9 px-2 flex items-center rounded-md gap-2 bg-brand-primaryColor"
              >
                <span>
                  <img src={FilterIcon} alt="Icon" />
                </span>
                <span className="text-white"> Filter</span>
              </button>
              {(taskFiltered || frequencyFiltered) && (
                <p
                  className="py-2 px-2 flex items-center gap-2 text-brand-primaryColor cursor-pointer"
                  onClick={handleClearFilter}
                >
                  Clear All
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="p-3">
          <div className="flex mb-4">
            {["Task", "Frequency"].map((tab, idx) => (
              <button
                key={idx}
                className={`px-4 py-2 ${
                  tab === "Task"
                    ? "rounded-l-md"
                    : tab === "Frequency"
                    ? "rounded-r-md"
                    : ""
                } 
                                        ${
                                          toggleState === tab
                                            ? "bg-brand-primaryColor text-white"
                                            : "bg-gray-200"
                                        }`}
                onClick={() => setToggleState(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          {toggleState === "Task" ? (
            <>
              <Tasks />
            </>
          ) : (
            <>
              <Frequency />
            </>
          )}
        </div>

        {/* Add new task/frequency */}
        <Modal
          title={toggleState === "Task" ? "Add Task" : "Add Frequency"}
          open={addNewModal}
          onCancel={() => handleNewModal("close")}
          footer={[]}
          destroyOnClose
          width={"30%"}
        >
          <>
            <Form ref={formRef} layout="vertical">
              <div>
                <div>
                  <Form.Item
                    label={
                      <span>
                        Title <span style={{ color: "#FF000F" }}>*</span>
                      </span>
                    }
                    name="title"
                  >
                    <Input placeholder="Enter" />
                  </Form.Item>
                </div>
                {toggleState === "Task" ? (
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Task
                          <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                      }
                      name="task"
                    >
                      <TextArea rows={4} placeholder="Enter" />
                    </Form.Item>
                  </div>
                ) : (
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Frequency
                          <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                      }
                      name="frequency"
                    >
                      <TextArea rows={4} placeholder="Enter" />
                    </Form.Item>
                  </div>
                )}
              </div>
            </Form>
            <div className="flex items-center w-full justify-end my-5">
              <button
                onClick={handleNewModal}
                className=" border rounded bg-white text-sm px-6 py-1.5"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={loader}
                className=" text-brand-White bg-[#189faa] text-white border rounded px-5 py-1.5  text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Submit
              </button>
            </div>
          </>
        </Modal>

        {/* Filter frequency / task */}
        <Modal
          title={"Filter"}
          open={filterModal}
          onCancel={handleFilterModal}
          footer={[]}
          width={"30%"}
          destroyOnClose
        >
          {toggleState === "Task" ? (
            <TaskFilter
              handleClose={handleFilterModal}
              setTaskFiltered={setTaskFiltered}
            />
          ) : (
            <FrequencyFilter
              handleClose={handleFilterModal}
              setFrequencyFiltered={setFrequencyFiltered}
            />
          )}
        </Modal>
      </div>
    </Layouts>
  );
}

export default Index;
